import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescriptionHidden,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'

interface UnsavedChangesDialogProps {
  open: boolean
  onLeave: () => void
  onStay: () => void
}

/**
 * Dialog shown when user tries to navigate away with unsaved changes.
 * Provides options to leave (discard changes) or stay on the current page.
 */
export function UnsavedChangesDialog({
  open,
  onLeave,
  onStay,
}: UnsavedChangesDialogProps) {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onStay()
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        hideCloseButton
        className="w-[370px] max-w-[370px] border-primary/50 rounded-md px-4 py-5 shadow-[0px_10px_22px_0px_#0000001A,0px_41px_41px_0px_#00000017,0px_92px_55px_0px_#0000000D,0px_163px_65px_0px_#00000003,0px_254px_71px_0px_#00000000]"
      >
        <DialogDescriptionHidden>
          You have unsaved changes. Are you sure you want to leave?
        </DialogDescriptionHidden>

        <div className="flex flex-col items-center text-center">
          <DialogTitle className="font-univers text-lg font-normal">
            Unsaved Changes
          </DialogTitle>
          <Typography
            variant="p"
            className="mt-2 font-univers text-base font-normal text-primary/80 leading-normal"
          >
            You have unsaved changes.
            <br />
            Are you sure you want to leave?
          </Typography>
          <div className="mt-4 flex gap-2">
            <Button
              variant="outline"
              onClick={onLeave}
              className="text-primary"
            >
              Leave
            </Button>
            <Button onClick={onStay}>Stay</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
